module.exports = __webpack_public_path__ + "static/media/giphy.011b859b.gif";